var _rect, _path, _g, _g2, _g3, _g4, _g5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.09075 34.8307V16.1468H34.8723V34.8307C34.8723 35.1801 34.5739 35.5 34.1884 35.5H7.77457C7.40573 35.5 7.09075 35.1965 7.09075 34.8307ZM25.7908 22.6608C26.6797 22.6608 27.4746 21.9412 27.4746 20.9915V20.6163C27.4746 19.7233 26.7371 18.947 25.7908 18.947H16.1723C15.2833 18.947 14.4884 19.6666 14.4884 20.6163V20.9915C14.4884 21.8845 15.2259 22.6608 16.1723 22.6608H25.7908ZM6.18382 6.5H35.7792C36.1469 6.5 36.4706 6.80469 36.5 7.22148V13.5755H5.5V7.16931C5.5 6.81992 5.79838 6.5 6.18382 6.5Z",
    fill: "url(#paint0_linear_23663_24477)",
    stroke: "url(#paint1_radial_23663_24477)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_23663_24477)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.2496 19.7186C33.3714 18.6171 34.8809 18 36.4531 18H48C51.3137 18 54 20.6863 54 24V48C54 51.3137 51.3137 54 48 54H30C26.6863 54 24 51.3137 24 48V30.3358C24 28.7254 24.6473 27.1826 25.7965 26.0544L32.2496 19.7186Z",
    fill: "url(#paint2_linear_23663_24477)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.2496 19.7186C33.3714 18.6171 34.8809 18 36.4531 18H48C51.3137 18 54 20.6863 54 24V48C54 51.3137 51.3137 54 48 54H30C26.6863 54 24 51.3137 24 48V30.3358C24 28.7254 24.6473 27.1826 25.7965 26.0544L32.2496 19.7186Z",
    fill: "url(#paint3_radial_23663_24477)",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.5999 20.0754C33.6283 19.0657 35.0119 18.5 36.4531 18.5H48C51.0376 18.5 53.5 20.9624 53.5 24V48C53.5 51.0376 51.0376 53.5 48 53.5H30C26.9624 53.5 24.5 51.0376 24.5 48V30.3358C24.5 28.8596 25.0934 27.4454 26.1468 26.4112L32.5999 20.0754Z",
    stroke: "url(#paint4_radial_23663_24477)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.5999 20.0754C33.6283 19.0657 35.0119 18.5 36.4531 18.5H48C51.0376 18.5 53.5 20.9624 53.5 24V48C53.5 51.0376 51.0376 53.5 48 53.5H30C26.9624 53.5 24.5 51.0376 24.5 48V30.3358C24.5 28.8596 25.0934 27.4454 26.1468 26.4112L32.5999 20.0754Z",
    stroke: "url(#paint5_radial_23663_24477)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_23663_24477)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48 36C48.5523 36 49 36.4477 49 37L49 38C49 38.5523 48.5523 39 48 39L31 39C30.4477 39 30 38.5523 30 38L30 37C30 36.4477 30.4477 36 31 36L48 36Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_23663_24477)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38 42C38.5523 42 39 42.4477 39 43L39 44C39 44.5523 38.5523 45 38 45L31 45C30.4477 45 30 44.5523 30 44L30 43C30 42.4477 30.4477 42 31 42L38 42Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_23663_24477)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48 30C48.5523 30 49 30.4477 49 31L49 32C49 32.5523 48.5523 33 48 33L31 33C30.4477 33 30 32.5523 30 32L30 31C30 30.4477 30.4477 30 31 30L48 30Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_b_23663_24477)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.2426 19.7574L25.7574 26.2426C24.6321 27.3679 24 28.894 24 30.4853V32.1667C24.0234 29.8587 25.9011 28 28.2092 28H28.9959C31.7596 28 34 25.7596 34 22.9959V21.3529C34 19.5088 35.4892 18.0108 37.3333 18H36.4853C34.894 18 33.3679 18.6321 32.2426 19.7574Z",
    fill: "url(#paint6_linear_23663_24477)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.2426 19.7574L25.7574 26.2426C24.6321 27.3679 24 28.894 24 30.4853V32.1667C24.0234 29.8587 25.9011 28 28.2092 28H28.9959C31.7596 28 34 25.7596 34 22.9959V21.3529C34 19.5088 35.4892 18.0108 37.3333 18H36.4853C34.894 18 33.3679 18.6321 32.2426 19.7574Z",
    fill: "url(#paint7_radial_23663_24477)",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.1109 26.5962L32.5962 20.1109C33.1063 19.6008 33.7063 19.2013 34.3589 18.9277C33.8217 19.5901 33.5 20.4341 33.5 21.3529V22.9959C33.5 25.4834 31.4834 27.5 28.9959 27.5H28.2092C26.8047 27.5 25.5427 28.1151 24.6795 29.0917C24.9247 28.1556 25.4149 27.2922 26.1109 26.5962Z",
    stroke: "url(#paint8_radial_23663_24477)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.1109 26.5962L32.5962 20.1109C33.1063 19.6008 33.7063 19.2013 34.3589 18.9277C33.8217 19.5901 33.5 20.4341 33.5 21.3529V22.9959C33.5 25.4834 31.4834 27.5 28.9959 27.5H28.2092C26.8047 27.5 25.5427 28.1151 24.6795 29.0917C24.9247 28.1556 25.4149 27.2922 26.1109 26.5962Z",
    stroke: "url(#paint9_radial_23663_24477)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_23663_24477",
    x: 18,
    y: 12,
    width: 42,
    height: 48,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_23663_24477"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_23663_24477",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_23663_24477",
    x: 30,
    y: 36,
    width: 20,
    height: 4,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_23663_24477"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_23663_24477",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_23663_24477",
    x: 30,
    y: 42,
    width: 10,
    height: 4,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_23663_24477"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_23663_24477",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_23663_24477",
    x: 30,
    y: 30,
    width: 20,
    height: 4,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_23663_24477"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_23663_24477",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_b_23663_24477",
    x: 18,
    y: 12,
    width: 25.3333,
    height: 26.1667,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_23663_24477"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_23663_24477",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_23663_24477",
    x1: 5,
    y1: 6,
    x2: 19.4115,
    y2: 36.7446,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF0400"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_23663_24477",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-3.61538 -8.42308) rotate(53.7949) scale(36.464 37.2516)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_23663_24477",
    x1: 24.9375,
    y1: 16.7586,
    x2: 53.9695,
    y2: 51.3773,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F09C9C",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A6D7F0",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_23663_24477",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(24.9375 16.7586) scale(28.125 47.1724)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_23663_24477",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(18.375 34.7586) rotate(42.2388) scale(22.1602 23.646)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_23663_24477",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(48.375 14.2759) rotate(117.863) scale(14.0417 12.3493)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_23663_24477",
    x1: 24.4167,
    y1: 17.5115,
    x2: 35.5229,
    y2: 32.4688,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F09C9C",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A6D7F0",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_23663_24477",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(24.4167 17.5115) scale(12.5 18.5632)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_23663_24477",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(21.5 24.5948) rotate(38.7972) scale(9.35587 9.79553)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_23663_24477",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(34.8333 16.5345) rotate(120.84) scale(5.68953 5.33051)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon4);
export default __webpack_public_path__ + "static/media/icon4.ef18341e6938198eecc2a0b170928575.svg";
export { ForwardRef as ReactComponent };